import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import * as actionTypes from "../actions/actionTypes"
import  clientServices from "../services/userServices";
import { USER_MANAGEMENT } from '../../../constants/comman';
// worker Saga: will be fired on USER_FETCH_REQUESTED actions
function* getClientsSaga(action: any) {
   try {
      const res = yield call(clientServices.getClients, action.payload);
      yield put({type: actionTypes.GET_CLIENTS_SUCCESS, payload: res});
   } catch (e) {
      console.log('getClientsSaga' + e);
   }
}

function* getMasterClientsSaga(action: any) {
   try {
      const res = yield call(clientServices.getMasterClients);
      yield put({type: actionTypes.GET_MASTER_CLIENTS_SUCCESS, payload: res});
   } catch (e) {
      console.log('getMasterClientsSaga' + e)
   }
}

function* getClientsListSaga(action: any) {
   try {
      const res = yield call(clientServices.getClientsWithoutPagination, action.payload);
      yield put({type: actionTypes.GET_CLIENTS_WITHOUT_PAGINATION_SUCCESS, payload: res});
   } catch (e) {
      console.log('getClientsSaga' + e);
   }
}

function* getRolesReportingToListSaga(action: any) {
   try {
      const res = yield call(clientServices.getRolesListWithoutPagination, action.payload);
      yield put({type: actionTypes.GET_ROLES_WITHOUT_PAGINATION_SUCCESS, payload: res});
   } catch (e) {
      console.log('getClientsSaga' + e);
   }  
}

function* getRolesSaga(action: any) {
   try {
      const res = yield call(clientServices.getRolesList, action.payload);
      yield put({type: actionTypes.GET_ROLES_SUCCESS, payload: res});
   } catch (e) {
      console.log('GET_ROLES_SUCCESS' + e);
   }
}

function* getDefaultRolesSaga(action: any) {
   try {
      const res = yield call(clientServices.getDefaultRolesList, action.payload);
      yield put({type: actionTypes.GET_DEFAULT_ROLES_SUCCESS, payload: res});
   } catch (e) {
      console.log('GET_DEFAULT_ROLES_SUCCESS' + e);
   }
}

function* getRoleByIdSaga(action: any) {
   try {
      const res = yield call(clientServices.getRoleById, action.payload);
      yield put({type: actionTypes.GET_ROLE_SUCCESS, payload: res});
      if(res && res.statusCode === 403) {
      yield put({type: actionTypes.EDIT_ROLE_FAILURE, payload: res});
      }
   } catch (e) {
      console.log('GET_ROLES_SUCCESS' + e);
   }
}

function* editRoleSaga(action: any) {
   try {
      const res = yield call(clientServices.editRole, action.payload);
      let status = res.status || res.statusCode;
      switch(status) {
         case 200:
            yield put({type: actionTypes.EDIT_ROLE_SUCCESS, payload: res}); break;
            case 500:
            yield put({type: actionTypes.EDIT_ROLE_FAILURE, payload: res}); break;
            case 422:
            yield put({type: actionTypes.EDIT_ROLE_FAILURE, payload: res}); break;
         default:
      } 
   } catch (e) {
      yield put({type: actionTypes.EDIT_ROLE_FAILURE, payload: e.response});
      console.log('EDIT_ROLE_FAILURE' + e.response);
   }
}

function* editUserSaga(action: any) {
   try {
      const res = yield call(clientServices.editUser, action.payload);
      let status = res.status || res.statusCode;
      switch(status) {
         case 200:
            yield put({type: actionTypes.EDIT_USER_SUCCESS, payload: res}); break;
            case 500:
            yield put({type: actionTypes.EDIT_USER_FAILURE, payload: res}); break;
         default:
      } 
   } catch (e) {
      console.log('GET_ROLES_SUCCESS' + e);
   }
}

function* getClientSaga(action: any) {
   try {
      const res = yield call(clientServices.getClient, action.payload);
      yield put({type: actionTypes.GET_CLIENT_SUCCESS, payload: res});
   } catch (e) {
      console.log('getClientsSaga' + e);
   }
}

function* addClientSaga(action: any) {
   try {
      // isIniitated true action
      yield put({type: actionTypes.IS_LOADING_TRUE});
      const res = yield call(clientServices.addClient, action.payload);
      switch(res.statusCode) {
         case 200:
            yield put({type: actionTypes.ADD_CLIENT_SUCCESS, payload: res}); break;
         case 400:
            yield put({type: actionTypes.ADD_CLIENT_FAILURE, payload: res}); break;
         default:
      }
   } catch (e) {
      yield put({type: actionTypes.IS_LOADING_FALSE});
      
      console.log(e);
      // isInitiated => false
   }
}

function* addRoleSaga(action: any) {
   try {
      const res = yield call(clientServices.addRole, action.payload);
      let status = res.status || res.statusCode;
      switch(status) {
         case 200:
            yield put({type: actionTypes.ADD_ROLE_SUCCESS, payload: res}); break;
         case 422:
            yield put({type: actionTypes.ADD_ROLE_FAILURE, payload: res}); break;
         default:
      }      
   } catch (e) {
      console.log('addRoleSaga');
      console.log(e.response);
      yield put({type: actionTypes.ADD_ROLE_FAILURE, payload: e.response});
   }
}
function* addUserSaga(action: any) {
   try {
      const res = yield call(clientServices.addUser, action.payload);
      let status = res.status || res.statusCode;
      switch(status) {
         case 200:
            yield put({type: actionTypes.ADD_USER_SUCCESS, payload: res}); break;
         case 500:
            yield put({type: actionTypes.ADD_USER_FAILURE, payload: res}); break;
         default:
            break;
      }      
   } catch (e) {
      console.log('addUserSaga');
      console.log(e.response);
      yield put({type: actionTypes.ADD_USER_FAILURE, payload: e.response});
   }
}

function* getUserByIdSaga(action: any) {
   try {
      const res = yield call(clientServices.getUserById, action.payload);
      yield put({type: actionTypes.GET_USER_SUCCESS, payload: res});
   } catch (e) {
      console.log('GET_USER_SUCCESS' + e);
   }
}

function* editClientSaga(action: any) {
   try {
      console.log('in edit saga');
      const res = yield call(clientServices.editClient, action.payload);
      switch(res.statusCode) {
         case 200:
            yield put({type: actionTypes.EDIT_CLIENT_SUCCESS, payload: res}); break;
         case 400:
            yield put({type: actionTypes.EDIT_CLIENT_FAILURE, payload: res}); break;
         default:
      }
   } catch (e) {
      console.log('editClientSaga');
      console.log(e)
   }
}

function* getUsersSaga(action: any) {
   try {
      let requestObject = null;
      if(action.payload.usersSearch){
      let status = action.payload.usersSearch.status !== '' ? ( action.payload.usersSearch.status === USER_MANAGEMENT.USERS.ACTIVE ? true : false ) : '';
            requestObject = {
               status:status,
               userDetails:action.payload.usersSearch.userDetails.join(',') || '',
               clientNames:action.payload.usersSearch.clients.join(',') || '',
               roleNames:action.payload.usersSearch.roles.join(',') || ''
            }
         }
         let pageNumber = action.payload.pageNumber;
         
      const res = yield call(clientServices.getUsers, {usersSearch: requestObject,pageNumber});
      yield put({type: actionTypes.GET_USERS_SUCCESS, payload: res});
   } catch (e) {
      console.log('getClientsSaga' + e);
   }
}

function* getSubjectListSaga(action: any) {
   try {
      const res = yield call(clientServices.getSubjectList, action.payload);
      yield put({type: actionTypes.GET_SUBJECT_LIST_SUCCESS, payload: res});
   } catch (e) {
      console.log('getClientsSaga' + e);
   }
}

function* getCourseListSaga(action: any) {
   try {
      const res = yield call(clientServices.getCourseList, action.payload);
      yield put({type: actionTypes.GET_COURSE_LIST_SUCCESS, payload: res});
   } catch (e) {
      console.log('getClientsSaga' + e);
   }
}

function* setBulkImportTestSaga(action: any) {
   try {
      const res = yield call(clientServices.setBulkImportTest, action.payload);
      switch(res.statusCode) {
         case 200:
            yield put({type: actionTypes.SET_BULK_IMPORT_TEST_SUCCESS, payload: res}); break;
      }
   } catch (e) {
      console.log('setBulkImportTestSaga');
      console.log(e)
   }
}
function* searchUserMgmtSaga(action: any) {
   try {
      console.log(action);
      let res;
      // res is clients data to be rendered
      let requestObject;

      switch(action.payload.selectedTab){
         case "Clients":
            requestObject = {
               searchQuery: action.payload.searchText || ''
            }
            res = yield call(clientServices.searchClients, requestObject);
            yield put({type: actionTypes.SEARCH_CLIENTS_SUCCESS, payload: {res: res, requestObject : requestObject}}); 
            break;
         case "Roles":
            requestObject = {
               roleNames:action.payload.rolesSearch.roles.join(',') || '',
               clientNames:action.payload.rolesSearch.clients.join(',') || '',
            }
            res = yield call(clientServices.searchRoles, requestObject);
            yield put({type: actionTypes.SEARCH_ROLES_SUCCESS, payload: {res:res, requestObject:requestObject}}); 
            break;
         case "Users":
            let status = action.payload.usersSearch.status !== '' ? ( action.payload.usersSearch.status === 'Active' ? true : false ) : '';
            requestObject = {
               isActive:status,
               userDetails:action.payload.usersSearch.userDetails.join(',') || '',
               clientNames:action.payload.usersSearch.clients.join(',') || '',
               roleNames:action.payload.usersSearch.roles.join(',') || ''
            }
            res = yield call(clientServices.searchUsers, requestObject);
            yield put({ type: actionTypes.SEARCH_USERS_SUCCESS, payload: {res: res, requestObject: requestObject}}); 
            break;
         default:
      }
      
   } catch (e) {
      console.log('searchClientsSaga' + e);
   }
}

function* setPaginationToPageOneSaga(action: any){
   try {
      yield put({type: actionTypes.SET_PAGINATION_TO_PAGE_ONE_SUCCESS}); 
   } catch (e) {
      console.log('setPaginationToPageOneSaga', e)
   }
}
function* resetPaginationToNullSaga(action: any){
   try {
      yield put({type: actionTypes.RESET_PAGE_NUMBER_TO_NULL_SUCCESS}); 
   } catch (e) {
      console.log('setPaginationToPageOneSaga', e)
   }
}

function* addRoleChipSaga(action: any){
   console.log(action);
try {
   yield put({type: actionTypes.ADD_ROLE_CHIP_SUCCESS, payload: action.payload})
} catch (e) {
   console.log('addRoleChipSaga', e)
}
}

function* removeRoleChipSaga(action: any){
   console.log(action)
   try {
      yield put({type: actionTypes.REMOVE_ROLE_CHIP_SUCCESS, payload: action.payload})
   } catch (e) {
      console.log('removeRoleChipSaga', e)
   }
}

function* addUsersChipSaga(action: any){
   try{
      yield put({type: actionTypes.ADD_USERS_CHIP_SUCCESS, payload: action.payload})
   } catch(e) {
      console.log('addUsersChipSaga', e)
   }
}

function* removeUsersChipSaga(action: any){
   try {
      yield put({type: actionTypes.REMOVE_USERS_CHIP_SUCCESS, payload: action.payload})
   } catch (e) {
      console.log('removeUsersChipSaga', e)
   }
}

function* clearChipsSaga(action: any) {
   try{
      yield put({type: actionTypes.CLEAR_CHIPS_SUCCESS})
   } catch(e){
      console.log('clearChipsSaga', e)
   }
}

function* setRolesSearchActiveOptionSaga(action: any){
   console.log(action)
   try {
      yield put({ type: actionTypes.SET_ROLES_SEARCH_ACTIVE_OPTION_SUCCESS, payload: action.payload})
   } catch (e) {
      console.log('setRolesSearchActiveOptionSaga', e)
   }
}

function* setUsersSearchActiveOptionSaga(action: any) {
  try {
    yield put({
      type: actionTypes.SET_USERS_SEARCH_ACTIVE_OPTION_SUCCESS,
      payload: action.payload,
    });
  } catch (e) {
    console.log("setUsersSearchActiveOption", e);
  }
}

function* setSearchQueryByTabSaga(action: any) {
   try {
      yield put({
         type: actionTypes.SET_SEARCH_QUERY_BY_TAB,
         payload: action.payload
      })
   } catch (e) {
      console.log('setSearchQueryByTabSaga', e)
   }
}


function* userManagementSaga() {
  yield takeLatest(actionTypes.GET_CLIENTS_REQUEST, getClientsSaga);
  yield takeLatest(actionTypes.GET_MASTER_CLIENTS_REQUEST, getMasterClientsSaga);
  yield takeLatest(actionTypes.GET_NEXT_CLIENT_PAGE, getClientsSaga);
  yield takeLatest(actionTypes.GET_PREV_CLIENT_PAGE, getClientsSaga);
  yield takeLatest(actionTypes.GET_CLIENT, getClientSaga);
  yield takeLatest(actionTypes.ADD_CLIENT, addClientSaga);
  yield takeLatest(actionTypes.EDIT_CLIENT, editClientSaga);
  yield takeLatest(actionTypes.GET_ROLES_LIST, getRolesSaga);
  yield takeLatest(actionTypes.GET_DEFAULT_ROLES_LIST, getDefaultRolesSaga);
  yield takeLatest(actionTypes.GET_CLIENTS_WITHOUT_PAGINATION_REQUEST, getClientsListSaga);
  yield takeLatest(actionTypes.GET_ROLES_WITHOUT_PAGINATION_REQUEST, getRolesReportingToListSaga);
  yield takeLatest(actionTypes.ADD_ROLE, addRoleSaga);
  yield takeLatest(actionTypes.GET_ROLE, getRoleByIdSaga);
  yield takeLatest(actionTypes.EDIT_ROLE, editRoleSaga);
  yield takeLatest(actionTypes.GET_USERS_REQUEST, getUsersSaga);
  yield takeLatest(actionTypes.GET_SUBJECT_LIST, getSubjectListSaga);
  yield takeLatest(actionTypes.GET_COURSE_LIST, getCourseListSaga);
  yield takeLatest(actionTypes.SET_BULK_IMPORT_TEST, setBulkImportTestSaga);

  yield takeLatest(actionTypes.ADD_USER, addUserSaga);
  yield takeLatest(actionTypes.GET_USER, getUserByIdSaga);
  yield takeLatest(actionTypes.EDIT_USER, editUserSaga);
  yield takeLatest(actionTypes.SEARCH_USER_MANAGMENT, searchUserMgmtSaga);
  yield takeLatest(actionTypes.SET_PAGINATION_TO_PAGE_ONE, setPaginationToPageOneSaga);
  yield takeLatest(actionTypes.RESET_PAGE_NUMBER_TO_NULL, resetPaginationToNullSaga);
  yield takeLatest(actionTypes.ADD_ROLE_CHIP, addRoleChipSaga);
  yield takeLatest(actionTypes.REMOVE_ROLE_CHIP, removeRoleChipSaga);
  yield takeLatest(actionTypes.ADD_USERS_CHIP, addUsersChipSaga);
  yield takeLatest(actionTypes.REMOVE_USERS_CHIP, removeUsersChipSaga);
  yield takeLatest(actionTypes.CLEAR_CHIPS, clearChipsSaga);
  yield takeLatest(actionTypes.SET_ROLES_SEARCH_ACTIVE_OPTION, setRolesSearchActiveOptionSaga);
  yield takeLatest(actionTypes.SET_USERS_SEARCH_ACTIVE_OPTION, setUsersSearchActiveOptionSaga);
  yield takeLatest(actionTypes.SET_SEARCH_QUERY_BY_TAB, setSearchQueryByTabSaga);
  
}

export default userManagementSaga;